import { Directive, Input, ElementRef, Renderer2, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appRequiredAsterisk]',
  standalone: true
})
export class RequiredAsteriskDirective implements OnInit {
  @Input('appRequiredAsterisk') isRequired: boolean = false;
  @Input() asteriskPosition: 'start' | 'end' = 'end';

  private asteriskElement: HTMLSpanElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.updateAsterisk();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isRequired'] || changes['asteriskPosition']) {
      this.updateAsterisk();
    }
  }

  private updateAsterisk() {
    if (this.asteriskElement) {
      this.renderer.removeChild(this.el.nativeElement, this.asteriskElement);
      this.asteriskElement = null;
    }

    if (this.isRequired) {
      this.asteriskElement = this.renderer.createElement('span');
      this.renderer.addClass(this.asteriskElement, 'required-asterisk');
      this.renderer.setProperty(this.asteriskElement, 'innerHTML', '*');
      this.renderer.setAttribute(this.asteriskElement, 'aria-hidden', 'true');

      if (this.asteriskPosition === 'start') {
        this.renderer.insertBefore(this.el.nativeElement, this.asteriskElement, this.el.nativeElement.firstChild);
      } else {
        this.renderer.appendChild(this.el.nativeElement, this.asteriskElement);
      }
    }
  }
}
